import { LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useFeatureAppConfig, useFeatureAppEnvironment, useMapGeneralController } from 'src/feature-app';
import { CalendarioCita } from 'src/feature-app/CalendarioCita';
import { useFeatureServices } from 'src/feature-app/hooks/use-feature-services';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { Availability, CalendarSlot, DealersData, Horario, OneFormState, Points } from 'src/types';
import { AvailabilityHistory, createAvailabilityManager, createHideCalendarHandler, createShowCalendarHandler, handleDmsMapExit as helperHandleDmsMapExit, handleNoDmsMapExit as helperHandleNoDmsMapExit } from './helpers/availabilityHelper';

export const JourneyCitaPosventaDealerController = () => {
	const { formData, formInfo, dealersInfo } = useSelector((state: OneFormState) => state);
	const { horario, dealer, dealerKvps }: { horario?: Horario; dealer?: DealersData; dealerKvps?: string } = formData.fields;
	const { points } = dealersInfo;
	const { handleNextStep } = useOneFormContext();
	const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
	const store = useStore();
	const dispatch = useDispatch();
	const env = useFeatureAppEnvironment();
	const config = useFeatureAppConfig();
	const [showCalendar, setShowCalendar] = useState<boolean>(false);
	// const [selectedPoint, handleSelectedPoint] = useState(null);
	const [error, setError] = useState(false);
	const [loadingPoint, setLoadingPoint] = useState(true);

	const [firstAvailability, setFirstAvailability] = useState<Availability>(null);
	const availabilityHistory = useRef<AvailabilityHistory[]>([]);
	const loadingLayer = useRef(null);
	const { selectedPoint, handleSelectedPoint } = useMapGeneralController();

	const [pointsToList, setPointsToList] = useState(null);
	const [selectedSlot, setSelectedSlot] = useState(null);

	useEffect(() => {
		setLoadingPoint(true);
		const point = points.find((point: Points) => {
			if (point.properties.dealer.kvps === dealer?.kvps || point.properties.dealer.kvps === dealerKvps) {
				return point;
			}
		});
		handleShowCalendar(point);
		setLoadingPoint(false);
	}, []);

	const availabilityManager = createAvailabilityManager(layerManager, store, env, setFirstAvailability, setError, availabilityHistory, loadingLayer);

	const { getAvailability } = availabilityManager;

	const handleShowCalendar = createShowCalendarHandler(getAvailability, handleSelectedPoint, setShowCalendar);

	const handleDmsMapExit = (slot: CalendarSlot | CalendarSlot[], point: Points) => {
		helperHandleDmsMapExit(slot, point, availabilityHistory.current, (payload) => {
			const appointmentDealer = createAppointmentDealer(payload.dealer);

			dispatch({
				type: 'UPDATE_FIELDS',
				payload: { ...payload, appointmentDealer },
			});
			handleNextStep();
		});
	};

	const createAppointmentDealer = (dealer: DealersData) => {
		const { markerInfo, dmsInfo } = dealer;

		return {
			assessors: dmsInfo.assessors ? [...dmsInfo.assessors] : undefined,
			dealerId: dmsInfo.dealerId ? { ...dmsInfo.dealerId } : { ...markerInfo.dealerInfo.dealerId },
			dmsAvailable: dmsInfo.dmsAvailable ? dmsInfo.dmsAvailable : false,
			email: dmsInfo.email ? dmsInfo.email : markerInfo.dealerInfo.mail,
			name: dmsInfo.name ? dmsInfo.name : markerInfo.dealerInfo.name,
			phone: dmsInfo.phone ? dmsInfo.phone : markerInfo.dealerInfo.phone,
			overhaulingServiceAvialable: dmsInfo.overhaulingServiceAvialable ? dmsInfo.overhaulingServiceAvialable : false,
			pickupCarServiceAvailabe: dmsInfo.pickupCarServiceAvailabe ? dmsInfo.pickupCarServiceAvailabe : false,
			replacementCarServiceAvailable: dmsInfo.replacementCarServiceAvailable ? dmsInfo.replacementCarServiceAvailable : false,
			reference: dmsInfo.reference,
		};
	};

	const handleNoDmsMapExit = (franjaHoraria: string, day: string, point: Points) => {
		helperHandleNoDmsMapExit(
			franjaHoraria,
			day,
			point,
			(payload) => {
				const appointmentDealer = createAppointmentDealer(payload.dealer);

				dispatch({
					type: 'UPDATE_FIELDS',
					payload: { ...payload, appointmentDealer },
				});
				handleNextStep();
			},
			availabilityHistory.current,
		);
	};

	const handleHideCalendarOnClick = createHideCalendarHandler(handleSelectedPoint, setShowCalendar);

	const renderCalendar = (): JSX.Element => {
		const { centerToCalculateDistance, userIsGeoLocated } = useMapGeneralController();

		return !loadingPoint && showCalendar && !error ? (
			<CalendarioCita
				selectedPoint={selectedPoint}
				paramAvailability={firstAvailability}
				getAvailability={getAvailability}
				selectedSlot={selectedSlot}
				setSelectedSlot={setSelectedSlot} // Comprobar
				handleDmsMapExit={handleDmsMapExit}
				handleNoDmsMapExit={handleNoDmsMapExit}
				center={centerToCalculateDistance.current}
				horario={horario}
				handleHideCalendarOnClick={handleHideCalendarOnClick}
				userIsGeoLocated={userIsGeoLocated}
				calendarIsStep
			/>
		) : null;
	};

	return renderCalendar();
};
